import { useCallback, useState } from 'react'

import { F0ButtonToggle } from '@factorialco/f0-react'
import { Desktop } from '@factorialco/f0-react/icons/app'
import { supportsScreenSharing } from '@livekit/components-core'
import { useLocalParticipant, useTracks } from '@livekit/components-react'
import { Track } from 'livekit-client'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

export const ScreenShareButton = () => {
  const { localParticipant } = useLocalParticipant()
  const [screenShareEnabled, setScreenShareEnabled] = useState(false)

  const browserSupportsScreenSharing = supportsScreenSharing()

  // Detect if screen sharing is currently active
  const screenShareTracks = useTracks(
    [{ source: Track.Source.ScreenShare, withPlaceholder: false }],
    { onlySubscribed: false }
  )

  // Check if local participant has an active screen share track
  const isScreenSharing = screenShareTracks.some(
    (track) => track.participant.isLocal && track.publication?.isEnabled
  )

  const handleScreenShareToggle = useCallback(async () => {
    try {
      if (screenShareEnabled) {
        await localParticipant.setScreenShareEnabled(false)
      } else {
        await localParticipant.setScreenShareEnabled(true, {
          audio: false,
          selfBrowserSurface: 'include',
        })
      }
      setScreenShareEnabled(!screenShareEnabled)
    } catch (error) {}
  }, [screenShareEnabled, localParticipant])

  if (!browserSupportsScreenSharing) {
    return null
  }

  return (
    <F0ButtonToggle
      label={
        isScreenSharing
          ? i18n.t('meetings.room.control_bar.screen_share.stop')
          : i18n.t('meetings.room.control_bar.screen_share.start')
      }
      onSelectedChange={() => {
        track(trackingEvents.meetings.ControlBarScreenShareButton, {
          isScreenSharing: !isScreenSharing,
        })
        handleScreenShareToggle()
      }}
      size="lg"
      selected={isScreenSharing}
      icon={Desktop}
    />
  )
}
